(() => {
  class WaccRewards extends HTMLElement {
    connectedCallback() {
      this.onToggle = (event) => {
        if (event.target.tagName !== 'DETAILS') return;
        event.target.querySelector('summary')?.setAttribute('aria-expanded', String(event.target.open));
      };
      this.addEventListener('toggle', this.onToggle, true);
      this.querySelectorAll('details').forEach((details) => {
        details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
      });
    }
    disconnectedCallback() {
      this.removeEventListener('toggle', this.onToggle, true);
    }
  }
  if (!customElements.get('wacc-rewards')) customElements.define('wacc-rewards', WaccRewards);
})();
